module.exports = __webpack_public_path__ + "static/media/Paras_gaussian2.8640ca98.png";